// No-op CartPerformance shim. The real implementation isn't shipped with this
// theme but cart.js / product-form.js / global.js reference it. Without a shim,
// `CartPerformance.measure(name, callback)` throws — and because the cart's
// section-rerender logic lives inside that callback, every cart update breaks
// (remove button, qty change, ATC update). The shim invokes the callback so
// the real logic runs; the performance markers themselves become no-ops.
if (typeof window !== 'undefined' && typeof window.CartPerformance === 'undefined') {
  window.CartPerformance = {
    createStartingMarker(name) { return null; },
    measure(name, fn) { if (typeof fn === 'function') return fn(); },
    measureFromMarker(name, marker) {},
    measureFromEvent(name, event) {},
  };
}

let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    const promises = subscribers[eventName]
      .map((callback) => callback(data))
    return Promise.all(promises);
  } else {
    return Promise.resolve()
  }
}
